module.exports = __webpack_public_path__ + "components/flag/static/square/ma-4d77402bb666dd86f6e5c7d665c08cf4.svg";